import {FunctionComponent} from 'react';
import ContainerCard from '@/components/container-card';
import Spinner from '@/components/spinner';
import Buttons from './buttons';
import Dialogs from './dialogs';
import Forms from './forms';
import Tables from './tables';
import Titles from './titles';

const DesignSystem: FunctionComponent = () => {
  return (
    <div className="mx-auto my-8 max-w-3xl">
      <ContainerCard>
        <h1 className="mb-2 text-5xl font-bold text-violet">Design System</h1>
        <p className="mb-10 text-base text-charcoal">En savoir plus sur les composantes utilisées dans ce projet</p>

        <div className="flex flex-col gap-7">
          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Boutons</h2>
            <Buttons />
          </div>

          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Dialog</h2>
            <Dialogs />
          </div>

          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Inputs</h2>
            <Forms />
          </div>

          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Tables</h2>
            <Tables />
          </div>

          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Titles</h2>
            <Titles />
          </div>

          <div>
            <h2 className="mb-3 rounded-3 bg-violet px-4 py-2 text-2xl font-bold text-white">Spinners</h2>
            <Spinner />
          </div>
        </div>
      </ContainerCard>
    </div>
  );
};

export default DesignSystem;
